import { ReactComponent as AlarmIcon } from 'assets/icons/svgs/icon-alarm.svg';
import { getLoginRedirectUrl } from '../booking-modal-utils';

import './BookingModalCallout.scss';

export const BookingModalCallout = () => (
  <div className="booking-modal__callout" data-testid="modal-callout">
    <div className="icon-alarm">
      <AlarmIcon data-testid="alarm-icon" />
    </div>
    <div>
      Remember to{' '}
      <a href={`/my-account/login?redirect_to=${getLoginRedirectUrl}`} className="link-secondary">
        sign in
      </a>{' '}
      to see special prices and to enjoy a faster checkout process
    </div>
  </div>
);
